import { render } from "./PageAjax.vue?vue&type=template&id=27324c6b"
import script from "./PageAjax.vue?vue&type=script&lang=js"
export * from "./PageAjax.vue?vue&type=script&lang=js"

import exportComponent from "/Users/aacassandra/Documents/vue3/aacassandra-github/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__